import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';

@Component({
  selector: 'app-refunds',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './refunds.component.html',
  styleUrl: './refunds.component.scss',
})
export class RefundsComponent {
  constructor(private titleService: Title, private metaService: Meta) {
    this.titleService.setTitle('Travel Insurance Refund Notice | World2Cover');
    this.metaService.updateTag({
      name: 'description',
      content: `World2Cover travel insurance refund notice: enjoy a 21-day cooling-off period to review your policy and cancel if it’s not the right cover for your trip.`,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Travel Insurance Refund Notice | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'World2Cover travel insurance refund notice: enjoy a 21-day cooling-off period to review your policy and cancel if it’s not the righ',
    });
  }
}
